<template>
  <div class="s_flex_ali m-b-20">
    <p class="width-119 text-ar" >商品信息：</p>
    <a-card-meta :title="form.name">
      <template #avatar>
        <img :src="info.picdomain+'/'+form.image" alt=""
          style="width:50px;height: 50px;object-fit:cover">
      </template>
      <template #description>
        <span v-if='form.price_type == 2'>{{form.price}}元+</span>
        <span>{{form.point}}积分</span>
      </template>
    </a-card-meta>
  </div>
  <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
    <a-form-item ref="" label="兑换模式" name="">
      <a-radio-group v-model:value="form.price_type">
        <a-radio :value="1">纯积分</a-radio>
        <a-radio :value="2">积分+现金</a-radio>
      </a-radio-group>
      <div class="s_flex_ali width100 " v-if='form.spec_type == 1'>
        <a-input-number class="width41" v-model:value="form.point" placeholder='请输入积分' :min="1" />
        <p class="m-l-10 m-r-10">积分+</p>
        <a-input-number class="width41" v-model:value="form.price" placeholder='请输入金额' v-inputFilter:price
          :disabled="form.price_type == 1" />
        <p class="m-l-10">现金</p>
      </div>
      <a-table class='m-t-25' :pagination='false' :loading='listLoading' bordered rowKey='sku_sn' :columns='columns' :data-source='form.sku' v-else>
        <template v-slot:info="{ record }">
          <a-card-meta>
            <template #avatar>
              <img :src="info.picdomain+record.image_url" alt="" style="width:50px;height: 50px;object-fit:cover">
            </template>
            <template #description>{{record.spec_value || record.sku_value}}</template>
          </a-card-meta>
        </template>
        <template v-slot:price="{ record }">
          <div class="s_flex_ali width100">
            <a-input-number class="width31" v-model:value="record.exchange_point" placeholder='请输入积分' :min="1" />
            <p class="m-l-10 m-r-10">积分+</p>
            <a-input-number class="width31" v-model:value="record.exchange_price" placeholder='请输入金额'
              v-inputFilter:price :disabled="form.price_type == 1" />
            <p class="m-l-10">现金</p>
          </div>
        </template>
      </a-table>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 7, offset: 3 }">
      <a-button type="primary" @click="onSubmit">
        保存
      </a-button>
    </a-form-item>
  </a-form>
</template>
<script>
  import { ref, onMounted, reactive, toRefs, inject } from 'vue';
  import { message } from 'ant-design-vue';
  import { iscode } from "@/utils/app";
  import {editGiftPrice,editGiftStock} from "@/api/integralShop";
  import store from "@/store";
  // 初始化默认筛选项数值
  let defForm = {
    id: '',
    spec_type:1,
    price_type: 1,
    point: '',
    price: '',
    sku:[]
  }
  export default {
    name: 'editPrice',
    components: {},
    props: {
      item: {
        type: Object
      }
    },
    setup(props, { emit }) {
      const form = ref({ ...defForm });
      const state = reactive({
        info: store.state.user.info,
        labelCol: { span: 3 },
        wrapperCol: { span: 18 },
        columns: [
          {
            title: "规格信息",
            dataIndex: "info",
            key: "info",
            slots: { customRender: "info" },
          },
          {
            title: "积分价格",
            dataIndex: "price",
            key: "price",
            slots: { customRender: "price" },
          }
        ]
      });
      const ruleForm = ref()
      const onSubmit = () => {
        ruleForm.value.validate().then(async() => {
          const hide = message.loading('正在加载中...', 0);
          let res = await editGiftPrice({...form.value,sku : form.value.spec_type == 1 ? '' : form.value.sku}).then(res => res.data).catch((error) => error);
          if (iscode(res)) {
            message.success(res.msg);
            emit("submit");
          } else {
            message.error(res.msg);
          }
          setTimeout(hide);
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      onMounted(() => {
        form.value = JSON.parse(JSON.stringify(props.item))
      });
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit
      }
    }
  }
</script>